import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=13426b46&scoped=true"
import script from "./PersonEdit.vue?vue&type=script&lang=js"
export * from "./PersonEdit.vue?vue&type=script&lang=js"
import style0 from "@/styles/_person_edit.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PersonEdit.vue?vue&type=style&index=1&id=13426b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13426b46",
  null
  
)

export default component.exports